// extracted by mini-css-extract-plugin
export default {"feedSectionItem":"social-skeletons-FeedSectionItemLoadingSkeleton__feedSectionItem--3f0re"};